"use client";

import { useEffect, useState } from "react";
import { LuArrowUpToLine } from "react-icons/lu";

import { Button } from "@/components/ui/button";

export const ScrollToTop = () => {
    const [ showTopButton, setShowTopButton ] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopButton(true);
            } else {
                setShowTopButton(false);
            }
        };

        handleScroll();

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleTopButtonClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            { showTopButton ? (
                <Button onClick={ handleTopButtonClick } className="fixed bottom-20 right-4 z-50 md:bottom-4" size="icon">
                    <LuArrowUpToLine className="size-4" />
                </Button>
            ) : null }
        </>
    );
};